<template>
  <drawer @close="close()" width="680">
    <v-container class="px-5 px-md-18 py-14 py-md-8 pa-md-20">
      <v-card-title
        class="display-1 font-weight-bold pa-0 mb-8 letter-spacing-normal"
      >
        Summary
        <v-progress-linear v-if="groupModel.fetching" indeterminate />
      </v-card-title>

      <v-row
        class="flex-column flex-md-row justify-lg-space-between align-center"
      >
        <v-col class="pa-0">
          <v-card-title class="py-0 font-weight-bold letter-spacing-normal">
            Select Tour
          </v-card-title>
        </v-col>
        <v-col class="text-md-right py-0 px-4 px-md-0 pa-md-0">
          <v-select
            :items="tours"
            item-text="name"
            item-value="id"
            v-model="selectedTour"
            label="Select Tours"
          />
        </v-col>
      </v-row>

      <v-row
        v-if="
          !group.sightings_reported || (groupModel.fetched && !sightings.length)
        "
        class="px-4 px-md-0  justify-lg-space-between align-center"
      >
        No sightings reported!
      </v-row>
      <v-card-text v-else class="pa-0">
        <v-row
          v-for="(summary, index) in report"
          :key="index"
          class="justify-lg-space-between align-center"
        >
          <v-col sm="12">
            <v-row class="justify-space-between align-center mb-10 mb-mb-0">
              <v-col class="pa-0">
                <v-card-title
                  class="py-0 title font-weight-bold letter-spacing-normal"
                >
                  {{ getSummaryTitle(summary.member) }}
                </v-card-title>
              </v-col>
              <v-col v-if="!group.checked_out" class="text-md-right pa-0">
                <v-btn
                  text
                  class="float-right pa-0 primary--text title font-weight-bold letter-spacing-normal"
                  @click="edit(summary.editStep)"
                >
                  Edit
                </v-btn>
              </v-col>
            </v-row>
            <v-row class="justify-lg-space-between align-center">
              <v-col class="pa-0">
                <v-skeleton-loader
                  v-if="!groupModel.fetched || groupModel.fetching"
                  height="180"
                  type="table-thead, table-tbody, table-tfoot"
                  class="mb-12"
                />
                <v-data-table
                  v-else
                  :headers="headers"
                  :items="summary.sightings"
                  v-bind="
                    summary.sightings.length > 5
                      ? { itemsPerPage: 5 }
                      : { hideDefaultFooter: true }
                  "
                  class="primary-table secondary-table border-radius-0 v-data-table-1 v-data-table-1--style3"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-container>
    <template v-slot:append>
      <div class="px-5 px-md-20 py-12">
        <v-btn block large class="primary" @click="close()">
          Done
        </v-btn>
      </div>
    </template>
  </drawer>
</template>

<script>
import Group from '@models/Group';
export default {
  name: 'Summary',
  components: {
    Drawer: () => import('@layouts/_partials/Drawer'),
  },
  props: {
    group: {
      type: Object,
      required: true,
      validator(data) {
        if (!data.id) {
          throw new Error('Invalid group object provided!');
        }
        return true;
      },
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Species',
          align: 'left',
          sortable: false,
          value: 'species.name',
        },
        { text: 'Count', value: 'count', width: 200 },
      ],
      groupModel: new Group({
        relations: [
          'tour',
          'attendees',
          'attendees.member',
          'attendees.species',
        ],
      }),
      sightings: [],
      selectedTour: '',
    };
  },
  computed: {
    currentSighting() {
      let self = this;
      if (!self.selectedTour) {
        return;
      }
      return self.sightings.find(
        (sighting) => sighting.tour_id === self.selectedTour
      );
    },
    report() {
      let self = this;
      let report = [];
      self.group.members.forEach((member, index) => {
        report.push({
          editStep: index + 2,
          member,
          sightings: !self.selectedTour
            ? []
            : self.sightings
                .find((sighting) => sighting.tour_id === self.selectedTour)
                .attendees.filter(
                  (attendee) => attendee.member_id === member.id
                )
                .map((attendee) => {
                  return {
                    species_id: attendee.species_id,
                    species: attendee.species,
                    count: attendee.count,
                  };
                }),
        });
      });
      return report;
    },
    tours() {
      return this.sightings.slice().map((sighting) => sighting.tour);
    },
  },
  methods: {
    async fetchSightings() {
      if (!this.group.sightings_reported) {
        return;
      }
      let response = await this.groupModel.fetchSightings(this.group.id);
      if (response) {
        this.sightings = response.data;
        if (this.sightings.length) {
          this.selectedTour = this.sightings[0].tour_id;
        }
      }
    },
    getSummaryTitle(member) {
      let name = member.first_name;
      if (name.endsWith('s')) {
        return `${name}' Sightings`;
      }
      return `${name}'s Sightings`;
    },
    edit(editStep) {
      this.$emit(
        'editSightingReport',
        editStep,
        this.sightings,
        this.currentSighting
      );
    },
    close() {
      this.$emit('exit');
    },
  },
  mounted() {
    this.fetchSightings();
  },
};
</script>
